import React , {StrictMode} from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
if (process.env.NODE_ENV === 'development') {
  const observer = new MutationObserver(() => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  });
  observer.observe(document.body, { childList: true });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router>
      <GoogleOAuthProvider clientId="1080120238188-g7oo7gp5da0e2l6br2309ri836o34dqk.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>


    </Router>
  </Provider>

);
